<template>
  <span v-text="text" />
</template>

<script>
import { CreativeTypes } from '@/models/Creative'

export default {
  name: 'AppCreativeType',
  props: {
    value: {
      type: String,
      default: CreativeTypes.BANNER,
      validator(value) {
        return Object.values(CreativeTypes).includes(value)
      },
    },
  },
  computed: {
    text() {
      switch (this.value) {
        case CreativeTypes.BANNER: {
          return 'バナー（静止画）'
        }
        case CreativeTypes.VIDEO: {
          return '動画'
        }
        case CreativeTypes.INFEED: {
          return 'インフィード'
        }
        case CreativeTypes.THREE_PAS: {
          return 'バナー（3PAS）'
        }
        case CreativeTypes.AUDIO: {
          return '音声'
        }
        default: {
          return this.value
        }
      }
    },
  },
}
</script>

<style></style>
